/**
 * Normalizes post-login redirect targets from query params.
 * Relative paths like "api/account/booking/1.pdf" must become absolute app paths.
 *
 * Only same-origin paths are ever returned: redirectTo arrives from the query
 * string, so echoing an absolute URL back into window.location would let
 * ?redirectTo=https://evil.example bounce a logged-in guest straight off site.
 */
export function normalizeRedirectTo(redirectTo, fallback = '/account') {
  if (!redirectTo || typeof redirectTo !== 'string') {
    return fallback;
  }

  // "//evil.example" and "https://evil.example" are both off-origin
  if (/^[a-z][a-z0-9+.-]*:/i.test(redirectTo) || redirectTo.startsWith('//')) {
    return fallback;
  }

  // "/\evil.example" and "\\evil.example" are treated as protocol-relative by some browsers
  if (redirectTo.startsWith('/\\') || redirectTo.startsWith('\\')) {
    return fallback;
  }

  if (redirectTo.startsWith('/')) {
    return redirectTo;
  }

  return `/${redirectTo}`;
}

export function shouldUseFullPageRedirect(redirectTo) {
  const target = normalizeRedirectTo(redirectTo, '');

  return target.startsWith('/api/');
}
